import { Flex } from "antd"


const mockData = [
    {label: 'India', cost: 1300},
    {label: 'Germany', cost: 1353},
    {label: 'Italy', cost: 1360},
    {label: 'Japan', cost: 1356},
    {label: 'China', cost: 1389},
    {label: 'Russia', cost: 1389},
    {label: 'Norway', cost: 1458},
    {label: 'Canada', cost: 1378}
    


]

const SummaryDetails = () => {


    return (
        <div className="summary-details">
            {
                mockData.map(data => {
                    return <Flex justify="space-between" align="center">
                            <p>{data.label}</p>
                            <p>{data.cost}</p>
                    </Flex>
                })
            }
        </div>
    )
}

export default SummaryDetails